<template>
  <div>
    <a-form
        :form="form"
        :label-col="{ span: 9 }"
        :wrapper-col="{ span: 7 }"
        @submit="submit"
    >
      <h3 style="text-align: center">Adres zameldowania</h3>
      <p style="text-align: center; max-width: 600px; margin: 12px auto">
        Adres zameldowania to adres pod którym jesteś zarejestrowany w urzędzie.
        Najczęściej jest to dom rodzinny. Nie należy go mylić z adresem
        zamieszkania.
        <br><br>
        <strong style="color: red">PROSIMY NIE WPISYWAĆ ADRESU AKADEMIKA, ZNAMY GO!</strong>
      </p>
      <a-form-item label="Ulica/Miejscowość">
        <a-input
            v-decorator="[
            'street-address',
            {
              rules: [
                {
                  required: true,
                  message: 'Ulica jest wymagana!',
                },
              ],
            },
          ]"
            :maxLength="250"
        />
      </a-form-item>
      <a-form-item label="Numer domu (i lokalu)">
        <a-input
            v-decorator="[
            'home-number',
            {
              rules: [
                {
                  required: true,
                  message: 'Numer domu jest wymagany!',
                },
              ],
            },
          ]"
            :maxLength="20"
        />
      </a-form-item>
      <a-form-item label="Kod pocztowy">
        <a-input
            v-decorator="[
            'postal-code',
            {
              rules: [
                {
                  required: true,
                  message: 'Kod pocztowy jest wymagany!',
                },
              ],
            },
          ]"
            :maxLength="10"
        />
      </a-form-item>
      <a-form-item label="Miasto">
        <a-input
            v-decorator="[
            'city',
            {
              rules: [
                {
                  required: true,
                  message: 'Miasto jest wymagane!',
                },
              ],
            },
          ]"
            :maxLength="250"
        />
      </a-form-item>
      <a-form-item label="Województwo">
        <a-input
            v-decorator="[
            'state',
            {
              rules: [
                {
                  required: false,
                  message: 'Województwo jest wymagane!',
                },
              ],
            },
          ]"
            :maxLength="250"
        />
      </a-form-item>
      <a-form-item class="certain-category-search-wrapper" label="Państwo">
        <a-auto-complete
            v-decorator="[
            'country',
            {
              rules: [
                {
                  required: true,
                  message: 'Państwo jest wymagane!',
                },
              ],
            },
          ]"
            :dataSource="countries"
            :dropdown-match-select-width="false"
            :filter-option="countryFilterOption"
            class="certain-category-search"
            dropdown-class-name="certain-category-search-dropdown"
            option-label-prop="value"
        >
          <template slot="dataSource">
            <a-select-opt-group v-for="group in countries" :key="group.title">
              <span slot="label">
                {{ group.title }}
              </span>
              <a-select-option
                  v-for="opt in group.children"
                  :key="opt"
                  :value="opt"
              >
                {{ opt }}
              </a-select-option>
            </a-select-opt-group>
          </template>
          <a-input>
            <a-icon slot="suffix" class="certain-category-icon" type="search"/>
          </a-input>
        </a-auto-complete>
      </a-form-item>
    </a-form>
    <a-row style="text-align: center">
      <a-button style="margin-right: 24px" type="default" @click="back">
        <a-icon type="left"/>
        Wróć
      </a-button>
      <a-button
          :disabled="!isVerificationCompleted"
          type="primary"
          @click="submit"
      >
        Dalej
        <a-icon type="right"/>
      </a-button>
    </a-row>
  </div>
</template>

<script>
const countriesDictionary = [
  {
    title: "Najczęściej wybierane",
    children: ["Polska", "Ukraine", "Turkey"],
  },
  {
    title: "Wszystkie",
    children: [
      "Afghanistan",
      "Åland Islands",
      "Albania",
      "Algeria",
      "American Samoa",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Indian Ocean Territory",
      "Brunei Darussalam",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cape Verde",
      "Cayman Islands",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Cocos (Keeling) Islands",
      "Colombia",
      "Comoros",
      "Congo",
      "Congo, The Democratic Republic of the",
      "Cook Islands",
      "Costa Rica",
      "Cote D'Ivoire",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands (Malvinas)",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Guiana",
      "French Polynesia",
      "French Southern Territories",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Heard Island and Mcdonald Islands",
      "Holy See (Vatican City State)",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran, Islamic Republic Of",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Korea, Democratic People'S Republic of",
      "Korea, Republic of",
      "Kuwait",
      "Kyrgyzstan",
      "Lao People'S Democratic Republic",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libyan Arab Jamahiriya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macao",
      "Macedonia, The Former Yugoslav Republic of",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mexico",
      "Micronesia, Federated States of",
      "Moldova, Republic of",
      "Monaco",
      "Mongolia",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "Northern Mariana Islands",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Palestinian Territory, Occupied",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Pitcairn",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russian Federation",
      "RWANDA",
      "Saint Helena",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia and Montenegro",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and the South Sandwich Islands",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Svalbard and Jan Mayen",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syrian Arab Republic",
      "Taiwan, Province of China",
      "Tajikistan",
      "Tanzania, United Republic of",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkmenistan",
      "Turks and Caicos Islands",
      "Tuvalu",
      "Uganda",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "United States Minor Outlying Islands",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Viet Nam",
      "Virgin Islands, British",
      "Virgin Islands, U.S.",
      "Wallis and Futuna",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe",
    ],
  },
];

export default {
  data() {
    return {
      countries: countriesDictionary,
      formLayout: "horizontal",
      form: this.$form.createForm(this, {name: "coordinated"}),
    };
  },
  mounted() {
    let data = this.$store.getters["getHomeData"];
    this.form.setFieldsValue({
      "street-address": data.street,
      "home-number": data.number,
      "postal-code": data.zipCode,
      city: data.city,
      state: data.state,
      country: data.country,
    });
  },
  methods: {
    submit: function () {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          var fixedDTO = {
            street: values["street-address"],
            number: values["home-number"],
            zipCode: values["postal-code"],
            city: values["city"],
            state: values["state"],
            country: values["country"],
          };

          this.$store.commit("updateHomeData", fixedDTO);
          this.$emit("nextStep");
        }
      });
    },
    back: function () {
      this.$emit("prevStep");
    },
    countryFilterOption: function (input, option) {
      return option.data.key.toUpperCase().indexOf(input.toUpperCase()) >= 0;
    },
  },
  computed: {
    isVerificationCompleted: function () {
      return true;
    },
  },
};
</script>

<style>
.certain-category-search-dropdown .ant-select-dropdown-menu-item-group-title {
  color: #666;
  font-weight: bold;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item-group {
  border-bottom: 1px solid #f6f6f6;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item {
  padding-left: 16px;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item.show-all {
  text-align: center;
  cursor: default;
}

.certain-category-search-dropdown .ant-select-dropdown-menu {
  max-height: 300px;
}
</style>
<style scoped>
.certain-category-search-wrapper
>>> .certain-category-search.ant-select-auto-complete
.ant-input-affix-wrapper
.ant-input-suffix {
  right: 12px;
}

.certain-category-search-wrapper >>> .certain-search-item-count {
  position: absolute;
  color: #999;
  right: 16px;
}

.certain-category-search-wrapper
>>> .certain-category-search.ant-select-focused
.certain-category-icon {
  color: #108ee9;
}

.certain-category-search-wrapper >>> .certain-category-icon {
  color: #6e6e6e;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 16px;
}
</style>
